

import { ArrowDownAZ, CalendarDays, Clock } from 'lucide-react';
import { 
  Select, 
  SelectContent, 
  SelectItem, 
  SelectTrigger, 
  SelectValue 
} from "@/components/ui/select";
import { Label } from '@/components/ui/label';
import { useIsMobile } from '@/hooks/use-mobile';

export type SortOption = 'alphabetical' | 'newest' | 'recent';

interface SortControlsProps {
  sortBy: SortOption;
  onSortChange: (option: SortOption) => void;
}

export function SortControls({ sortBy, onSortChange }: SortControlsProps) {
  const isMobile = useIsMobile();
  
  return (
    <div className="flex items-center space-x-2">
      {!isMobile && (
        <Label htmlFor="sort-by" className="text-sm font-medium">Sort by:</Label>
      )}
      <Select value={sortBy} onValueChange={(value) => onSortChange(value as SortOption)}>
        <SelectTrigger id="sort-by" className={`${isMobile ? 'w-[42px] px-2 justify-center' : 'w-[160px]'}`}>
          {isMobile ? (
            sortBy === 'alphabetical' ? <ArrowDownAZ className="h-4 w-4" /> :
            sortBy === 'newest' ? <Clock className="h-4 w-4" /> :
            <CalendarDays className="h-4 w-4" />
          ) : (
            <SelectValue placeholder="Sort by" />
          )}
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="alphabetical">
            <div className="flex items-center">
              <ArrowDownAZ className="mr-2 h-4 w-4" />
              <span>Alphabetical</span>
            </div>
          </SelectItem>
          <SelectItem value="newest">
            <div className="flex items-center">
              <Clock className="mr-2 h-4 w-4" />
              <span>Newest First</span>
            </div>
          </SelectItem>
          <SelectItem value="recent">
            <div className="flex items-center">
              <CalendarDays className="mr-2 h-4 w-4" />
              <span>Most Recent</span>
            </div>
          </SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
